module.exports = __webpack_public_path__ + "static/media/logo.d650c88b.svg";